<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-form-group#input-group-name(, label="Nombre", label-for="input-name")
      b-form-input#input-name(,
        v-model="form.name",
        placeholder="Nombre",
        :state="$v.$dirty ? !$v.form.name.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido
    b-form-group#input-group-responsableCollaborator(,
      label="Responsable",
      label-for="input-responsable"
    )
       b-form-select(
            v-model="form.responsableCollaborator"
            :state="$v.$dirty ? !$v.form.responsableCollaborator.$invalid : null"
            id="input-responsable"
            :options="getCollaborator()"
          )
          div(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.responsableCollaborator.required") Este campo es requerido
    b-form-group#input-group-expirationDate(,
      label="Día de vencimiento ",
      label-for="input-expirationDate"
    )
      b-form-input#input-expirationDate(,
        v-model="form.expirationDate",
        placeholder="Día de vencimiento",
        type="number",
        min=1,max=31,
        :state="$v.$dirty ? !$v.form.expirationDate.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.expirationDate.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.expirationDate.between") El día debe estar entre 1 y 31
    b-form-group
      b-form-checkbox#showInSummary-input(
        v-model="form.showInSummary",
        :state="$v.$dirty ? !$v.form.showInSummary.$invalid : null"
      ) Mostrar resumen
      div(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.showInSummary.required") Este campo es requerido
    .modal-footer
      b-button(type="submit") {{ editMode ? 'Guardar' : 'Crear' }}
</template>
<script>
import { required, between } from "vuelidate/lib/validators";
import { mapActions , mapGetters} from "vuex";
export default {
  props: {
    editMode: Boolean
  },
  validations: {
    form: {
      name: { required },
      responsableCollaborator: { required },
      expirationDate: { required , between:between(1,31)},
      showInSummary: { required }
    },
  },
  data() {
    return {
      form: {
        id: null,
        name: '',
        responsableCollaborator: null,
        expirationDate: null,
        showInSummary: false
      },
    };
  },
  methods: {
    ...mapActions(["editTask", "createTask", 'getTask']),
    ...mapActions('UserStore',['listUsers']),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const payload = this.form;
        const action =
          !this.editMode ? this.createTask : this.editTask;
        const response = await action(payload)
        console.log(response)
        this.$root.$bvToast.toast(response.status === 200 ? 'Tarea guardada correctamente' : 'Error al guardar la tarea', 
        {
          title: response.status === 200 ? 'Éxito!' : 'Ocurrió un error!',
          variant: response.status === 200 ? 'success' : 'danger'
        })
        this.getTask(this.$route.params.taskId)
      }
    },
    getCollaborator () {
      const collaboratorOptions = []
      this.users.forEach(user => {
        if(user.role === 'collaborator' || user.role === 'owner'){
          collaboratorOptions.push({
            text: user.name +' '+ user.lastName,
            value: user.id
          })
        }
      })
      return collaboratorOptions
    }
  },
  watch: {
    task () {
      if (this.task) {
        console.log (this.task.responsableCollaborator)
        this.form = {
          id: !this.editMode ? null : this.task.id,
          name: !this.editMode ? null : this.task.name,
          responsableCollaborator: !this.editMode ? null : this.task.responsableCollaborator,
          expirationDate: !this.editMode ? null : this.task.expirationDate,
          showInSummary: !this.editMode ? false : (this.task.showInSummary || false)
        }
      }
    }
  },
  computed :{
    ...mapGetters(['task']),
    ...mapGetters('UserStore',['users'])
  },
  created(){
    this.listUsers()
  }
};
</script>